import { Observable } from 'rxjs';
import { Dispositif, DispositifCreateData } from './dispositif';

export abstract class DispositifRepository {
  abstract getAll(): Observable<Dispositif[]>;
  abstract getById(id: number): Observable<Dispositif>;
  abstract create(data: DispositifCreateData): Observable<Dispositif>;
  abstract update(id: number, data: DispositifCreateData): Observable<Dispositif>;
  abstract delete(id: number): Observable<void>;
}
